import { render, staticRenderFns } from "./chat-box.vue?vue&type=template&id=207c25f3&scoped=true"
import script from "./chat-box.vue?vue&type=script&lang=js"
export * from "./chat-box.vue?vue&type=script&lang=js"
import style0 from "./chat-box.vue?vue&type=style&index=0&id=207c25f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c25f3",
  null
  
)

export default component.exports